module.exports = __webpack_public_path__ + "img/slack.0dba1665.svg";